import { ApplicationConfig } from '@angular/core';

import { guards } from './guards';
import { DataSourcesStore } from './store/data-sources.store';
import {SourceGroupStore} from "@src/app/data-sources/store/source-group.store";

export const dataSourcesConfig: ApplicationConfig = {
  providers: [
    DataSourcesStore,
    SourceGroupStore,
    guards
  ]
}
